import { Component, inject, Input, OnInit } from '@angular/core';
import { UploadFileService } from 'src/app/shared/services/upload-file.service';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { Toast, ToastrService } from 'ngx-toastr';
import { DateUtil } from 'src/app/shared/util/date.util';
import { FormBuilder } from '@angular/forms';
import { Constant } from 'src/app/core/constant';
import { ProductService } from '../../product.service';
import { FileUploader } from 'ng2-file-upload';
import { UploaderService } from 'src/app/shared/services/uploader.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { EventManager } from 'src/app/core';
import { ModalComponent } from '../../../../shared/components/modal.component';
declare let $;
@Component({
  selector: 'app-upload-document-fund-popup',
  templateUrl: './upload-document-fund-popup.component.html',
  styleUrls: ['./upload-document-fund-popup.component.scss'],
  providers: [UploadFileService]
})
export class UploadDocumentFundPopupComponent extends ModalComponent implements OnInit {
  @Input() productId: string = '';
  @Input() typeCode: string = '';
  file: any;
  fileName: string = '';
  tday = null;
  isSaved: boolean = false;
  isUpload: boolean = false;
  uploaderImage: FileUploader;
  urlImage: string = '';
  subscriptions?: Subscription[] = [];
  documents: any[] = [
    {name: 'Bản cáo bạch', code: 'PROSPECTUS_FUND'},
    {name: 'Bản cáo bạch tóm tắt', code: 'SUMMARY_PROSPECTUS_FUND'},
    {name: 'Điều lệ quỹ', code: 'REGULATION_FUND'},
  ]
  readonly nzModalData: any = inject(NZ_MODAL_DATA);
  constructor(
    private modalRef : NzModalRef,
    public eventManager: EventManager,
    private uploaderService: UploaderService,
    private productService: ProductService,
    private toastService: ToastrService,
    public formBuilder: FormBuilder
  ) {
    super(eventManager);
  }
  ngOnInit() {
    super.ngOnInit();
    this.uploaderImage = this.uploaderService.initUploader(
      environment.urlUploadBackEnd + Constant.API_UPLOAD, 'upload-file', null, {applyOriginalFileName:true, MAX_FILE_SIZE: 1000 * 1024 * 1024});
    this.subscriptions = [
      this.eventManager.subscribe('upload-file', (res) => {
        this.urlImage = res.content.imagePath;
        this.isUpload = false;
      }),
      this.eventManager.subscribe('uploading-file', (res) => {
        this.isUpload = true;
      }),
      this.eventManager.subscribe('uploading-file-done', (res) => {
        this.isUpload = false;
      }),
    ];
  }
  uploadFile(index?, item?) {
    $('#fileInput').val('');
    setTimeout(() => {
      $('#fileInput').click();
    }, 50)
  }
  changeType(event) {
    this.typeCode = event.code;
    
    switch (this.typeCode) {
      case 'PROSPECTUS_FUND':
        this.fileName = 'Bản cáo bạch';
      break;
      case 'SUMMARY_PROSPECTUS_FUND':
        this.fileName = 'Bản cáo bạch tóm tắt';
      break;
      default:
        this.fileName = 'Điều lệ quỹ';
      break;
    }
  }
  selectFile(event) {
    const files = event.target.files;
    const fileName = files[0].name || '';
    this.fileName = fileName.split('.')[0];
  }
  async save() {
    this.isSaved = true;
    if (!this.urlImage || !this.tday || !this.productId || !this.typeCode || !this.fileName || this.isUpload) {
      this.toastService.warning('Uploading. Wait a minute please.');
      return;
    }
    const body = {
      fileName: this.fileName,
      applyAt: DateUtil.parseDate(this.tday, 'dd/MM/yyyy'),
      productId: this.productId,
      typeCode: this.typeCode,
      url: this.urlImage,
    }
    return this.productService.addProductDocument(body)
    .subscribe(
      (res: any) => {
        this.toastService.success('Upload file thành công!');
        this.cancel();
        setTimeout(() => {
          this.eventManager.broadcast({
            name: 'load-page',
            content: {
              page:  1,
            }
          });
        }, 2000)
      },
      async (err) => {
        const message = JSON.parse(await err.error.text()).message;
        this.toastService.error(message, 'Error');
      },
    )
  }
  cancel() {
    this.modalRef.close();
  }
  checkDateNull() {
    return DateUtil.checkDateNull(this.tday);
  }
}
